import commonAction from './commonAction';
import * as types from '../constants/actionsTypes';
import API from '../api';

const api = new API();

/**
 * Метод загрузки списка юзеров (выводится на странице Add User)
 */
export const loadUsers = () => {
	return dispatch => commonAction(dispatch, 'get', 'newApi/api/v1/users', {}, 'LOAD_USERS', 'users');
}

/**
 * Метод удаления юзера
 * @param {string} userId
 */
export const deleteUser = userId => {
	return dispatch => commonAction(dispatch, 'post', '/users/delete', { userId }, 'DELETE_USER', 'users');
}

/**
 * Метод добавления юзера
 * @param {object} fromData
 */
export const addUser = formData => {
	return dispatch => commonAction(dispatch, 'post', '/users/add', formData, 'ADD_USER', 'users');
}

export const loadUserDetail = userId => {
	return dispatch => commonAction(dispatch, 'post', '/users/view', {userId}, 'LOAD_USER_DETAILS', 'user');
}

export const clearUserErrors = () => ({
	type: types.CLEAR_USER_ERROR
});



// WEBPACK FOOTER //
// ./actions/userActions.js